export default __webpack_public_path__ + "static/mdv-7b2065eefd1d750fe1ec214b8d407f43.jpg";